import { render, staticRenderFns } from "./GroupTeachersList.vue?vue&type=template&id=19812e49&scoped=true&"
import script from "./GroupTeachersList.vue?vue&type=script&lang=js&"
export * from "./GroupTeachersList.vue?vue&type=script&lang=js&"
import style0 from "./GroupTeachersList.vue?vue&type=style&index=0&id=19812e49&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19812e49",
  null
  
)

export default component.exports